import { FormattedMessage } from "react-intl";

import { useModal } from "@/context/modal/modal";

import { PrimaryButton } from "@/pages/shared/shared.styles";

import { AddUserIcon24, MultipleFilterIcon24 } from "@/components/icons";
import AddUserModalContent from "@/components/ui/modal-with-context/modal-contents/users-page/add-user/add-user-modal-content";
import SearchBar from "@/components/ui/search-bar/search-bar";

import { DropdownFilterVariant } from "@/types/filters";
import { SearchBarVariant } from "@/types/search-bar";

import { UserMultiSelectDropdown } from "../users-filter";

import type { OptionsBarProps } from "./options-bar.types";

import { ButtonText, OptionsBarWrapperDiv } from "./options-bar.styles";

const OptionsBar = ({
    onInputChange,
    refetchUsersData,
    searchInputValue,
    selectedRoles,
    selectedStatus,
    onRoleChange,
    onStatusChange,
}: OptionsBarProps) => {
    const { openModal, setWidth, setMinHeight } = useModal();

    const handleAddUserButtonClick = () => {
        setWidth("540px");
        setMinHeight("352px");
        openModal({
            content: (
                <AddUserModalContent
                    title="users:users-table:modal-contents:add-user:title"
                    description="users:users-table:modal-contents:add-user:description"
                    refetchUsersData={refetchUsersData}
                />
            ),
        });
    };

    return (
        <OptionsBarWrapperDiv>
            <PrimaryButton onClick={handleAddUserButtonClick}>
                <AddUserIcon24 fill="#121212" />
                <ButtonText>
                    <FormattedMessage id={"users:options-bar:button:text"} />
                </ButtonText>
            </PrimaryButton>
            <SearchBar
                variant={SearchBarVariant.PrimaryGrey800}
                disabled={false}
                debounceTimeout={400}
                placeholder="Search..."
                value={searchInputValue}
                onChange={onInputChange}
            />
            <UserMultiSelectDropdown
                variant={DropdownFilterVariant.PrimaryGrey800}
                selectedRoles={selectedRoles}
                selectedStatus={selectedStatus}
                onRoleChange={onRoleChange}
                onStatusChange={onStatusChange}
                title="Filters"
                icon={<MultipleFilterIcon24 />}
            />
        </OptionsBarWrapperDiv>
    );
};

export default OptionsBar;
